<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    style="height: 90vh;"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="11" sm="8" md="6" lg="5" xl="5">
        <v-card class="elevation-6">
          <div class="pa-7 pa-sm-12">
            <v-row>
              <v-col cols="8" class="px-0">
                <img src="@/assets/logo-black.svg" style="width: 92px;" />
              </v-col>
              <v-col cols="4" class="px-0 text-right">
                <languages-menu :small="true" />
              </v-col>
            </v-row>
            <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">
              {{ $vuetify.lang.t('$vuetify.LOG_IN') }}
            </h2>
            <v-form
              ref="form"
              v-model="valid"
              action="/dashboards/analytical"
              @keyup.native.enter="valid && login()"
            >
              <v-text-field
                v-model="email"
                :rules="emailRules"
                :label="$vuetify.lang.t('$vuetify.LOGIN.EMAIL')"
                class="mt-4"
                required
                outlined
              ></v-text-field>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                :label="$vuetify.lang.t('$vuetify.LOGIN.PASSWORD')"
                required
                outlined
                :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                :type="passwordVisible ? 'text' : 'password'"
                @click:append="() => (passwordVisible = !passwordVisible)"
              ></v-text-field>

              <span :style="{ opacity: error ? 1 : 0 }" class="error--text">
                {{ error ? error.message : '' }}
              </span>

              <div class="d-block d-sm-flex align-center pb-4 mb-sm-0">
                <!-- <v-checkbox
                  v-model="rememberMe"
                  label="Remember me?"
                  hide-details
                ></v-checkbox> -->
                <div class="ml-auto">
                  <a
                    style="color: #007CAD;"
                    class="secondary--text"
                    @click="$router.push('/forgot-pwd')"
                  >
                    {{ $vuetify.lang.t('$vuetify.LOGIN.FORGOT_PASSWORD') }}
                  </a>
                </div>
              </div>
              <v-btn
                :disabled="!valid"
                color="secondary"
                block
                class="mr-4"
                submit
                @click="login()"
              >
                {{ $vuetify.lang.t('$vuetify.LOG_IN') }}
              </v-btn>
            </v-form>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import LanguagesMenu from '@/components/commonComponents/LanguagesMenu'
import { landingForUser } from '@/utils/landing'

export default {
  name: 'Login',
  components: {
    LanguagesMenu
  },
  data: () => ({
    valid: false,
    password: '',
    passwordVisible: false,
    passwordRules: [v => !!v || 'Password is required'],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ],
    get rememberMe() {
      return localStorage.getItem('rememberMe') === 'true'
    },
    // eslint-disable-next-line vue/no-dupe-keys
    set rememberMe(value) {
      localStorage.setItem('rememberMe', value)
    }
  }),
  computed: {
    ...mapGetters('app', ['error']),
    ...mapGetters('authentication', ['user'])
  },
  created() {
    this.$store.dispatch('authentication/logout')
  },
  methods: {
    login() {
      if (!this.email.length && !this.password.length) return
      this.$store
        .dispatch('authentication/login', {
          username: this.email,
          password: this.password
        })
        .then(() => {
          const target = landingForUser(this.user)
          if (target.external) {
            window.location.href = target.path
          } else {
            this.$router.replace(target.path)
          }
        })
    }
  }
}
</script>
